import { render, staticRenderFns } from "./CardSectionElementCard.vue?vue&type=template&id=0550c841"
import script from "./CardSectionElementCard.vue?vue&type=script&lang=js"
export * from "./CardSectionElementCard.vue?vue&type=script&lang=js"
import style0 from "./CardSectionElementCard.vue?vue&type=style&index=0&id=0550c841&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports